import loadable from '@loadable/component';
import { useContext, type FunctionComponent, type HTMLAttributes } from 'react';
import { useInView } from 'react-intersection-observer';
import { ProductFamilyContext } from '../../../contexts/product-family/product-family.context';
import { ProductSearchProvider } from '../../../contexts/product-search/product-search.context';
import { VariantContext } from '../../../contexts/variant/variant.context';
import { booleanFromQueryString } from '../../../helpers/general-helper/general-helper';
import { useRouteSearchParams } from '../../../hooks/routing/params.hook';

const LoadableProductListResults = loadable(
	() => import(/* webpackChunkName: "product-list-results" */ './search-product-list-results.component'),
	{
		resolveComponent: ({ ProductListResults }) => ProductListResults
	}
);

export type SearchProductListsProps = Pick<HTMLAttributes<HTMLElement>, 'className'>;
export const SearchProductLists: FunctionComponent<SearchProductListsProps> = ({ className = 'mt4 mt5-l w-100' }) => {
	const defaultClasses = 'dn flex-ns flex-column justify-center';
	const { ref: sectionRef, inView: isVisible } = useInView({ triggerOnce: true, rootMargin: '0px 0px 200px 0px' });
	const [queryParams] = useRouteSearchParams();
	const { productFamily } = useContext(ProductFamilyContext);
	const { selectedVariant } = useContext(VariantContext);

	return (
		<ProductSearchProvider
			internalId={productFamily.id}
			uniqueId={selectedVariant.id}
			isNonstock={booleanFromQueryString(queryParams.get('ns'))}>
			<section className={`${defaultClasses} ${className}`} ref={sectionRef} data-testid="search-product-lists">
				{isVisible && <LoadableProductListResults />}
			</section>
		</ProductSearchProvider>
	);
};
